// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip {
  position: absolute;
  background-color: #303338;
  color: white;
  padding: 10px 14px;
  border-radius: 12px;
  max-width: 200px;
  text-align: center;
  z-index: 10;
  transform: translateY(20px);
  opacity: 0.9; /* Начальное состояние */
  animation: show 0.3s ease;
}

@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.9;
  }
}

/* Стрелка сверху */
.arrow {
  position: absolute;
  bottom: 100%; /* Переместили стрелку вверх */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #333; /* Указываем вниз */
  animation: show 0.3s ease;
}
`, "",{"version":3,"sources":["webpack://./src/Tooltip.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,YAAY,EAAE,wBAAwB;EACtC,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,YAAY,EAAE,8BAA8B;EAC5C,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B,EAAE,mBAAmB;EACnD,yBAAyB;AAC3B","sourcesContent":[".tooltip {\r\n  position: absolute;\r\n  background-color: #303338;\r\n  color: white;\r\n  padding: 10px 14px;\r\n  border-radius: 12px;\r\n  max-width: 200px;\r\n  text-align: center;\r\n  z-index: 10;\r\n  transform: translateY(20px);\r\n  opacity: 0.9; /* Начальное состояние */\r\n  animation: show 0.3s ease;\r\n}\r\n\r\n@keyframes show {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 0.9;\r\n  }\r\n}\r\n\r\n/* Стрелка сверху */\r\n.arrow {\r\n  position: absolute;\r\n  bottom: 100%; /* Переместили стрелку вверх */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 10px solid transparent;\r\n  border-right: 10px solid transparent;\r\n  border-bottom: 10px solid #333; /* Указываем вниз */\r\n  animation: show 0.3s ease;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
